<template>
  <div class="event-body">
    <div v-if="eventData" class="wrap">
      <div class="event-list">
        <ul class="event-row02">
          <li v-for="(eventItem, index) in eventData" :key="index">
            <a href="#" v-for="(event, index2) in eventItem" :key="index2" @click.prevent="detailPage(event.eventid)">
              <span class="con-img">
                <img :src="event.listimage | imageUrl" alt=""/>
              </span>
              <span class="con-text-wrap">
                <strong class="event-con-tit">{{event.eventtitle}}</strong>
                <span v-if="event.announcementdate" class="event-tr">
                  <strong class="event-th">발표</strong>
                  <span class="event-td">{{event.announcementdate}}</span>
                </span>
              </span>
            </a>
          </li>
        </ul>
      </div>
      <PagingComponent
        :current-page="currentPage"
        :page-count="pageCount"
        :limit="limit"
        :paging-count="pagingCnt"
        wrapper-class="paging-type02"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import PagingComponent from '@/components/common/PagingComponent'
import { getEventsNotice } from '@/common/utils/request'
import { imageUrl } from '@/common/filters/url.filter'
import { scrollTop } from '@/common/utils/common'

export default {
  name: 'app',
  components: {
    PagingComponent
  },
  filters: {
    imageUrl
  },
  data () {
    return {
      isLoading: false,
      eventData: {},
      totalCount: 0,
      limit: 10,
      currentPage: 1,
      pagingCnt: 10,
      pageCount: 0
    }
  },
  methods: {
    setSubList (tempObj, rowCnt = 2) {
      // 스브 리스트 셋팅
      let i = 0
      let tempList = []
      const restList = []

      for (i = 0; i < tempObj.list.length; i++) {
        tempList.push(tempObj.list[i])
        // rowCnt만큼의 서브Row 생성
        if (i % rowCnt !== 0) {
          restList.push(tempList)
          tempList = []
        }
        // 마지막 홀수개 처리
        if (((i + 1) === tempObj.list.length) && tempObj.list.length % 2 !== 0) {
          restList.push(tempList)
        }
      }
      return restList
    },
    detailPage (eventId) {
      this.$router.push({
        name: 'event_board_view',
        query: {
          eventId: eventId,
          pageNum: this.currentPage
        }
      })
    },
    getEventsNoticeList () {
      this.isLoading = true
      scrollTop()
      this.currentPage = Number(_.get(this.$route, ['query', 'page'], '1'))
      let offset = (this.currentPage - 1) * this.limit // [sean:QA30-4097,4102]

      // 당첨자 발표
      getEventsNotice({ offset, limit: this.limit }).then(({ data }) => {
        this.pageCount = Number(_.get(data, 'pagecount', '1'))
        this.totalCount = Number(_.get(data, 'totalcount', '0'))
        this.eventData = this.setSubList(data, 2)
        this.isLoading = false
      })
    }
  },
  created () {
    this.getEventsNoticeList()
  },
  watch: {
    $route (to, from) {
      this.getEventsNoticeList()
    }
  }
}
</script>
<style lang="css" src="@/assets/css/event.css"></style>
